import React from "react";
import i18n from "../../../i18n";
import { useTranslation } from "react-i18next";

export function bindI18nEvents() {
	i18n.on("loaded", () => {
		i18n.loadNamespaces("common/attribute_type_field");
		updateTranslations();
	})
	i18n.on("languageChanged", () => {
		i18n.loadNamespaces("common/attribute_type_field");
		updateTranslations();
	})
}

function updateTranslations() {
	Object.keys(typeText).forEach((key) => {
		if (i18n.hasLoadedNamespace("common/attribute_type_field")) {
			typeText[key] = i18n.t(key, { ns: "common/attribute_type_field" });
		}
	})
}

export const typeText = {
	String: "Text",
	"Picklist String": "Dropdown",
	Number: "Number",
	DateTime: "Date Time",
	"User Identity": "User Identity",
	Email: "Email",
	URL: "Link",
	Html: "Rich Content",
	Boolean: "True/False",
	"Multiline Text": "Long Text",
	Tags: "Tags",
	"Entity Lookup": "Referenced Property",
	"State Field": "State",
	"Shared Lookup": "Shared Property",
	"Tree Dropdown": "Tree Dropdown",
	"Attachment": "Attachment",
};

const AttributeTypeField = ({ attributeType }) => {
	const { t } = useTranslation("common/attribute_type_field");
	const getTypeValue = (type) => {
		const translatedType = t(typeText[type] || type);
		return translatedType;
	}

	return (
		<div className="disabled-input-wrapper">
			<input className="form-control" value={getTypeValue(attributeType)} disabled />
		</div>
	);

};

AttributeTypeField.displayName = "AttributeTypeField";

export default AttributeTypeField;
